import React from "react";
import { useMobileTts } from "./useMobileTts";
import AudioPresentational from "./AudioPresentational";

interface Props {
  text: string;
  onPlay: () => unknown;
  onStop: () => unknown;
}

function MobileAudio(props: Props) {
  const { text, onPlay, onStop } = props;
  const [play, stop, playing] = useMobileTts(text);

  return <AudioPresentational play={play} stop={stop} playing={playing} onPlay={onPlay} onStop={onStop} />;
}

export default MobileAudio;
